// extracted by mini-css-extract-plugin
module.exports = {"loading":"reference-list__loading___3kfkW","panel":"reference-list__panel___jV5k4"};